// frontend/src/lib/templateApi.ts
import api from './api';

export interface TemplateRow {
  id: number;
  template_name: string;
  resource_type: string | null;
  template_content: string;
  version: number;
}

export interface TestMessageRow {
  id: number;
  name: string;
  message_type: string;
  description: string | null;
}

export interface ValidationResult {
  valid: boolean;
  errors: string[];
  warnings: string[];
  fhir_output: string;
  test_message_used: string;
  version?: number;
}

export const templateApi = {
  /** List all JSONata templates */
  list: (): Promise<TemplateRow[]> =>
    api.get('/api/v1/admin/config/jsonata-templates').then(r => r.data),

  /** List all test messages */
  listTestMessages: (): Promise<TestMessageRow[]> =>
    api.get('/api/v1/admin/config/test-messages').then(r => r.data),

  /** Test a template against a test message WITHOUT saving */
  test: (params: {
    template_content: string;
    resource_type: string;
    test_message_name: string;
  }): Promise<ValidationResult> =>
    api.post('/api/v1/admin/config/templates/test', params).then(r => r.data),

  /** Validate + save template (STRICT — returns 400 on error) */
  save: (
    name: string,
    params: { template_content: string; resource_type: string }
  ): Promise<ValidationResult> =>
    api.put(`/api/v1/admin/config/templates/${name}`, params).then(r => r.data),
};
